export const PLACEHOLDER_PIPELINE_YAML = `jobs:
  Job1:
    name: Job 1
    steps:
      - type: script
        script-content: echo "Hello, world!"
`

export const hasNoStoredPipelineYaml = (
  yaml: string | null | undefined,
  versionedSettings: {storedInRepo?: boolean; format?: string | null} | null | undefined,
): boolean =>
  (yaml ?? '') === '' &&
  versionedSettings?.storedInRepo === true &&
  versionedSettings?.format === 'pipelines-yaml'
